import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gob-notices-page',
  templateUrl: './notices-page.component.html',
  styleUrls: ['./notices-page.component.css']
})
export class NoticesPageComponent implements OnInit {
conditions: any;
generales: any;

  constructor() { }

  ngOnInit(): void {
  }

}
